import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import Sidebar from './Sidebar'
import '../styles/commingsoon.css'
import { db, firebasevalue } from '../firebase'
import { useAuth } from '../context/AuthProvider'
function Vote() {

    const [videos, setVideos] = useState([])
    const [artwork,setArtwork] =useState([])
    const [photos,setPhotos] =useState([])
    const [poems,setPoems] =useState([])
    const [articles,setArticles] =useState([])
    const [filter,setFilter] =useState("artwork")

    const {currentUser} = useAuth()
    useEffect(()=>{
        db.collection("events").doc("thewallartwork").onSnapshot((docs)=>{
            if(docs.exists)
            {
                var result = Object.keys(docs.data().voting).map((orderBy) => docs.data().voting[orderBy]); 

                result.sort((a,b)=>b.vote-a.vote)
               
                setArtwork([result[0]]) 
            }
        })
    },[])
    
    useEffect(()=>{
        db.collection("events").doc("shutterbugphotos").onSnapshot((docs)=>{
            if(docs.exists)
            {
                var result = Object.keys(docs.data().voting).map((orderBy) => docs.data().voting[orderBy]); 

                result.sort((a,b)=>b.vote-a.vote)
               
                setPhotos([result[0]]) 
            }
        })
    },[])

    useEffect(()=>{
        db.collection("events").doc("thewallpoetry").onSnapshot((docs)=>{
            if(docs.exists)
            {
                var result = Object.keys(docs.data().voting).map((orderBy) => docs.data().voting[orderBy]); 

                result.sort((a,b)=>b.vote-a.vote)
                
                setPoems([result[0]]) 
            }
        })
    },[])

    useEffect(()=>{
        db.collection("events").doc("thewallarticle").onSnapshot((docs)=>{
            if(docs.exists)
            {
                var result = Object.keys(docs.data().voting).map((orderBy) => docs.data().voting[orderBy]); 

                result.sort((a,b)=>b.vote-a.vote)
               
                setArticles([result[0]]) 
            }
        })
    },[])

    return (
        <Container fluid={true}>

          <h1 className="section-heading mt-4">Winner - public Choice</h1>
                <Container fluid>
                    <Row>
                        <Col lg={2} xs={6}>
                            <Button className="transparent_button w-100" onClick={()=>setFilter("artwork")}>Artwork</Button>
                        </Col>
                        <Col lg={2} xs={6}>
                            <Button className="transparent_button w-100" onClick={()=>setFilter("article")}>Article</Button>
                        </Col>
                        <Col lg={2} xs={6}>
                            <Button className="transparent_button w-100" onClick={()=>setFilter("poetry")}>Poetry</Button>
                        </Col>
                        
                        <Col lg={2} xs={6}>
                            <Button className="transparent_button w-100" onClick={()=>setFilter("shutterbugphotos")}>Shutterbug</Button>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Row className="mt-5">
                        {filter ==='artwork' && artwork && artwork.length>0 && artwork.map((art,index)=>{
                            if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('thewallartwork') && currentUser.voted["thewallartwork"] != art.submittedBy)
                            {
                                return(<Col lg={3} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./artwork/${art.submittedBy}-min.jpg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            else if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('thewallartwork') && currentUser.voted["thewallartwork"] === art.submittedBy) {
                                return(<Col lg={3} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./artwork/${art.submittedBy}-min.jpg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            else
                            {
                                return(<Col lg={3} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./artwork/${art.submittedBy}-min.jpg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            
                        })

                        }
                        
                        {filter ==='shutterbugphotos' && photos && photos.length>0 && photos.map((art,index)=>{
                            if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('shutterbugphotos') && currentUser.voted["shutterbugphotos"] != art.submittedBy)
                            {
                                return(<Col lg={3} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./shutterbug/${art.submittedBy}-min.jpg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }else if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('shutterbugphotos') && currentUser.voted["shutterbugphotos"] === art.submittedBy) {
                                return(<Col lg={3} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./shutterbug/${art.submittedBy}-min.jpg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            else
                            {
                                return(<Col lg={3} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./shutterbug/${art.submittedBy}-min.jpg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            
                        })

                        }

                        {filter ==='poetry' && poems && poems.length>0 && poems.map((art,index)=>{
                            if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('thewallpoetry') && currentUser.voted["thewallpoetry"] != art.submittedBy)
                            {
                                return(<Col lg={6} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./poetry/${art.submittedBy}.png`} className="item-holder-image img-fluid" />
                                    <div className="participant_count mt-0">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }else if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('thewallpoetry') && currentUser.voted["thewallpoetry"] === art.submittedBy) {
                                return(<Col lg={6} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./poetry/${art.submittedBy}.png`} className="item-holder-image img-fluid" />
                                    <div className="participant_count mt-0">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            else
                            {
                                return(<Col lg={6} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./poetry/${art.submittedBy}.png`} className="item-holder-image img-fluid" />
                                    <div className="participant_count mt-0">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            
                        })

                        }

                        {filter ==='article' && articles && articles.length>0 && articles.map((art,index)=>{
                            if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('thewallarticle') && currentUser.voted["thewallarticle"] != art.submittedBy)
                            {
                                return(<Col lg={6} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./article/${art.submittedBy}.jpeg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count mt-0">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }else if(typeof currentUser.voted === "object" && currentUser.voted.hasOwnProperty('thewallarticle') && currentUser.voted["thewallarticle"] === art.submittedBy) {
                                return(<Col lg={6} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./article/${art.submittedBy}.jpeg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count mt-0">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            else
                            {
                                return(<Col lg={6} md={3} className="item-container" key={index}>
                                <div className="item-holder">
                                    <img src={`./article/${art.submittedBy}.jpeg`} className="item-holder-image img-fluid" />
                                    <div className="participant_count mt-0">
                                        <span>Total Votes</span>
                                        {art.vote}
                                    </div>
                                </div>
                            </Col>)

                            }
                            
                        })

                        }
                    </Row>
                </Container>

          </Container>
    )
}

export default Vote
